import type { FC, RefObject } from 'react';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTable';

import Spreadsheet from '@/components/UI/SpreadSheet/Spreadsheet';
import type { SpreadsheetSettings } from '@/components/UI/SpreadSheet/SpreadSheet.model';

import type { AnimalIdentifierData } from './AssignIdentifiers.utils';
import type { HoTcolumns } from './AssignIdentifiers.utils';

interface AssignIdentifiersTableProps {
  data: Array<AnimalIdentifierData>;
  columns: typeof HoTcolumns;
  innerRef: RefObject<HotTableRef | null>;
  beforeChange: (changes: Array<[number, string | number, unknown, unknown]> | null) => void;
  afterChange: (changes: Array<[number, string | number, unknown, unknown]> | null, source: string) => void;
  maxRows: number;
  setInvalid: (invalid: boolean) => void;
}

const AssignIdentifiersTable: FC<AssignIdentifiersTableProps> = ({
  data,
  columns,
  innerRef,
  beforeChange,
  afterChange,
  maxRows,
  setInvalid,
}) => {
  const settings: SpreadsheetSettings = {
    columns: columns as unknown as SpreadsheetSettings['columns'],
    colWidths: 200,
    colHeaders: true,
    rowHeaders: true,
    height: 500,
    rowHeights: 50,
    manualColumnResize: true,
    outsideClickDeselects: true,
    minSpareRows: 0,
    columnSorting: false,
    contextMenu: false,
    className: 'htMiddle',
  };

  return (
    <Spreadsheet
      data={data as unknown as Array<Record<string, unknown>>}
      settings={settings}
      innerRef={innerRef as RefObject<HotTableRef>}
      className="mt3"
      beforeChange={beforeChange}
      afterChange={afterChange}
      maxRows={maxRows}
      addCol={false}
      setInvalid={setInvalid}
      testPrefix="assign-identifiers"
    />
  );
};

export default AssignIdentifiersTable;
